import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star, PlayCircle, CheckCircle, Clock, Heart } from 'lucide-react';
export function WatchTracker() {
  const [hoveredStar, setHoveredStar] = useState(0);
  const [rating, setRating] = useState(0);
  const [isLiked, setIsLiked] = useState(false);
  return <div className="flex flex-col gap-8" data-id="element-81">
      {/* Stats Header */}
      <div data-id="element-82">
        <h2 className="text-lg font-serif text-white/90 mb-4 flex items-center gap-2" data-id="element-83">
          <Clock className="w-4 h-4 text-rose-500" data-id="element-84" />
          Watch Tracker
        </h2>
        <div className="grid grid-cols-3 gap-3" data-id="element-85">
          <div className="bg-dark border border-white/5 rounded-xl p-3 text-center" data-id="element-86">
            <div className="text-2xl font-serif text-white mb-1" data-id="element-87">2</div>
            <div className="text-[10px] text-white/50 uppercase tracking-wider" data-id="element-88">
              Watching
            </div>
          </div>
          <div className="bg-dark border border-white/5 rounded-xl p-3 text-center" data-id="element-89">
            <div className="text-2xl font-serif text-white mb-1" data-id="element-90">47</div>
            <div className="text-[10px] text-white/50 uppercase tracking-wider" data-id="element-91">
              Completed
            </div>
          </div>
          <div className="bg-dark border border-white/5 rounded-xl p-3 text-center" data-id="element-92">
            <div className="text-2xl font-serif text-white mb-1" data-id="element-93">12</div>
            <div className="text-[10px] text-white/50 uppercase tracking-wider" data-id="element-94">
              Plan to
            </div>
          </div>
        </div>
      </div>

      {/* Currently Watching */}
      <div data-id="element-95">
        <h3 className="text-xs font-medium text-white/50 uppercase tracking-widest mb-4" data-id="element-96">
          Currently Watching
        </h3>
        <div className="flex flex-col gap-4" data-id="element-97">
          {/* Item 1 */}
          <div className="group cursor-pointer" data-id="element-98">
            <div className="flex justify-between text-sm mb-2" data-id="element-99">
              <span className="text-white/90 font-medium group-hover:text-rose-400 transition-colors" data-id="element-100">
                Frieren
              </span>
              <span className="text-white/50 text-xs" data-id="element-101">Ep 18 / 28</span>
            </div>
            <div className="h-1.5 w-full bg-white/10 rounded-full overflow-hidden" data-id="element-102">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: `${18 / 28 * 100}%`
            }} transition={{
              duration: 1,
              delay: 0.5
            }} className="h-full bg-rose-500 rounded-full relative" data-id="element-103">
                <div className="absolute right-0 top-0 bottom-0 w-4 bg-white/30 blur-[2px]" data-id="element-104" />
              </motion.div>
            </div>
          </div>

          {/* Item 2 */}
          <div className="group cursor-pointer" data-id="element-105">
            <div className="flex justify-between text-sm mb-2" data-id="element-106">
              <span className="text-white/90 font-medium group-hover:text-rose-400 transition-colors" data-id="element-107">
                Vinland Saga S2
              </span>
              <span className="text-white/50 text-xs" data-id="element-108">Ep 12 / 24</span>
            </div>
            <div className="h-1.5 w-full bg-white/10 rounded-full overflow-hidden" data-id="element-109">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: `${12 / 24 * 100}%`
            }} transition={{
              duration: 1,
              delay: 0.6
            }} className="h-full bg-rose-500 rounded-full relative" data-id="element-110">
                <div className="absolute right-0 top-0 bottom-0 w-4 bg-white/30 blur-[2px]" data-id="element-111" />
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Rate Micro-interaction */}
      <div className="relative mt-4" data-id="element-112">
        <div className="absolute -inset-0.5 bg-gradient-to-b from-rose-500/20 to-transparent blur-md rounded-2xl opacity-50" data-id="element-113" />
        <div className="relative bg-[#0f0f0f] border border-white/10 rounded-2xl p-5" data-id="element-114">
          <div className="flex items-start justify-between mb-4" data-id="element-115">
            <div data-id="element-116">
              <div className="text-[10px] text-rose-400 font-bold uppercase tracking-widest mb-1" data-id="element-117">
                Rate Last Watched
              </div>
              <h4 className="text-sm font-medium text-white/90" data-id="element-118">
                Frieren - Ep 18
              </h4>
              <p className="text-xs text-white/50 mt-0.5" data-id="element-119">"The Heroes"</p>
            </div>
            <button onClick={() => setIsLiked(!isLiked)} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors" data-id="element-120">
              <Heart className={`w-4 h-4 transition-colors ${isLiked ? 'fill-rose-500 text-rose-500' : 'text-white/50'}`} data-id="element-121" />
            </button>
          </div>

          <div className="flex items-center justify-between mt-6" data-id="element-122">
            <div className="flex gap-1" onMouseLeave={() => setHoveredStar(0)} data-id="element-123">
              {[1, 2, 3, 4, 5].map(star => <button key={star} onMouseEnter={() => setHoveredStar(star)} onClick={() => setRating(star)} className="p-1 transition-transform hover:scale-110 focus:outline-none" data-id="element-124">
                  <Star className={`w-6 h-6 transition-all duration-200 ${(hoveredStar || rating) >= star ? 'fill-rose-500 text-rose-500 drop-shadow-[0_0_8px_rgba(244,63,94,0.5)]' : 'fill-transparent text-white/20'}`} data-id="element-125" />
                </button>)}
            </div>

            <motion.div initial={false} animate={{
            opacity: rating > 0 ? 1 : 0,
            scale: rating > 0 ? 1 : 0.8
          }} className="text-xs font-medium text-rose-400 bg-rose-500/10 px-2 py-1 rounded" data-id="element-126">
              Logged
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
}